



















































































































import { createComponent, onMounted, ref, watch, computed } from '@vue/composition-api'
import { currentCode, isEdit, setState } from '@/assets/code-edit'
import { currentPage, Page } from '@/assets/page'
import { getDocHeight, parseCodeValid } from '@/assets/util'
import { MessageBox } from 'element-ui'
import { fxList, varList } from '@/assets/event'
import { initGlobalConfig } from '@/components/mobile-render/render/utils'

export default createComponent({
  setup () {
    const areaHeight = ref(0)
    const code = ref('')
    const isCodeValid = ref(true)
    const canMount = ref(false)
    const canMountAfterLoading = ref(false)
    const editor = ref<{
      getPosition: any,
      executeEdits: any,
      setPosition: any,
      focus: any
    }>(null)
    watch(() => currentCode.code, (val: string) => {
      code.value = val
    })
    // 必须等到动画过完才能渲染编辑器
    watch(() => isEdit.value, val => {
      if (val) {
        canMountAfterLoading.value = true
        // hide popover
        document.body.click()
        setTimeout(() => {
          canMount.value = true
        }, 500)
      } else {
        canMount.value = false
      }
    })
    onMounted(() => {
      areaHeight.value = getDocHeight()
    })
    const handleCancel = () => {
      setState(false)
    }
    const handleConfirm = async (close = true) => {
      if (!isCodeValid.value) {
        await MessageBox.confirm('代码存在语法错误，不会保存错误的代码，是否继续？')
      }
      const updateRes = currentCode.update(code.value)
      if (updateRes !== false) {
        window.globalApp.$notify({
          title: '成功',
          message: `保存 ${currentCode.title}`,
          type: 'success',
          duration: 2000,
          position: 'top-left'
        })
        if (close) {
          handleCancel()
        }
      }
    }
    const handleClickFx = (item: any) => {
      if (editor.value) {
        const position = editor.value.getPosition()
        editor.value.executeEdits('', [
          {
            range: {
              startLineNumber: position.lineNumber,
              startColumn: position.column,
              endLineNumber: position.lineNumber,
              endColumn: position.column
            },
            text: item.code
          }
        ])
        position.column += item.code.length
        editor.value.setPosition(position)
        editor.value.focus()
      }
    }
    // const hasLeftCodeTitle = ['页面方法', 'render']
    const isCodeRender = computed(() => currentCode.title === 'render')
    type ResItem = { label: string, value: string, children: ResItem[] }
    const codeRenderNotice = ref<{ state: ResItem[], methods: ResItem[] }>({ state: [], methods: [] })
    const isObj = (obj: any) => obj && typeof obj === 'object' && !Array.isArray(obj)
    const _df = (
      obj: any,
      path: string[],
      res: Array<ResItem>
    ): any => {
      if (isObj(obj)) {
        Object.keys(obj).forEach((k: string) => {
          const item = { label: k, value: `${path.join('.')}.${k}`, children: [] }
          res.push(item)
          if (isObj(obj[k])) {
            path.push(k)
            _df(obj[k], path, item.children)
            path.pop()
          }
        })
      }
    }
    watch(() => [isCodeRender.value, currentPage.value], ([isRender, page]) => {
      if (page) {
        // console.log('computed page`s state !')
        codeRenderNotice.value.state = []
        const { state } = page as Page
        const ctx = { $$page: { state: {}, methods: {} }, $$global: initGlobalConfig(page as Page) }
        // 解析视图
        const stateRes = parseCodeValid(state, ctx)
        if (stateRes.ok) {
          const result: Array<ResItem> = []
          _df(stateRes.value, [], result)
          codeRenderNotice.value.state = result
        }
        if (isRender) {
          // console.log('computed page`s methods !')
          // 重置
          codeRenderNotice.value.methods = []
          const { methods } = page as Page
          const ctx = { $$page: { state: {}, methods: {} }, $$global: initGlobalConfig(page as Page) }
          // 解析方法
          const methodsRes = parseCodeValid(methods, ctx)
          if (methodsRes.ok) {
            const result: Array<ResItem> = []
            _df(methodsRes.value, [], result)
            codeRenderNotice.value.methods = result
          }
        }
      }
    }, { lazy: true })
    return {
      areaHeight,
      code,
      canMount,
      canMountAfterLoading,
      isEdit,
      currentCode,
      amdRequire: window.require,
      hasLeftPanel: computed(() => currentCode.title !== '系统配置'),
      isCodeRender,
      codeRenderNotice,
      fxList,
      varList,
      handleClickFx,
      handleNodeClick (data: any) {
        handleClickFx({ code: `$$page.state${data.value[0] === '.' ? '' : '.'}${data.value}` })
      },
      handleCancel,
      handleConfirm,
      handleCodeChange (val: string) {
        code.value = val
      },
      handleMounted (editorInstance: any) {
        editor.value = editorInstance
        canMountAfterLoading.value = false
        editorInstance.addCommand(window.monaco.KeyMod.CtrlCmd | window.monaco.KeyCode.KEY_S, function () {
          handleConfirm(false)
        })
        editorInstance.addCommand(window.monaco.KeyMod.CtrlCmd | window.monaco.KeyCode.KEY_D, function () {
          handleCancel()
        })
      }
    }
  }
})
